import { memo, useEffect, useState } from 'react';

import { t } from '../../../languages';

import { Spin } from 'antd';
import moment from 'moment';
import { MAXEXERCISESECONDS } from '../../../modules/competition';
import { genCompetitionRanking, genExerciseStats } from '../../../utils';
import { genExerciseComponent } from '../../../utils/componentwrapper';
import MyCountDown from '../../Utils/time/MyCountDown';
import MyTimer from '../../Utils/time/MyTimer';
import ShowCompetitionResults from './ShowCompetitionResults';
import ShowStudentResult from './ShowStudentResult';


const COUNT_DOWN_SECS = 4;

// Playing -> students competing
const StudentCompetitionStage3 = ({ lang, theCompetition, handleExpireTime, user, saveResponse }) => {
    const [currentExercise, setCurrentExercise] = useState(0);
    const [enterExercise, setEnterExercise] = useState(false);
    const [waitingNext, setWaitingNext] = useState(false);

    useEffect(() => {
        const _currentExercise = theCompetition.currentExercise || 0;
        setCurrentExercise(_currentExercise);
    }, [theCompetition.currentExercise]);

    const handleResponse = (eid, uid, result, timereq) => {
        // console.log('StudentCompetitionStage3: handleResponse:', eid, uid, result, timereq);
        const aResponse = {
            uid: user.id,
            p: result.p || 0,
            t: timereq,
            d: new Date().getTime()
        };
        // console.log(`StudentCompetitionStage3.handleResponse: aResponse:`, aResponse);

        saveResponse(theCompetition.id, `e${currentExercise}`, aResponse);
    }

    // console.log('StudentCompetitionStage3 theCompetition:', theCompetition);

    const exercises = theCompetition.exercises;
    const responses = theCompetition.responses;
    const responsesKeys = responses ? Object.keys(responses) : null;
    const startedTime = theCompetition.startedTime ? moment(new Date(theCompetition.startedTime)) : null;
    const expiryTime = startedTime ? startedTime.clone().add(MAXEXERCISESECONDS, 'seconds') : null;
    const currentTime = moment();
    const fStartedTime = startedTime ? startedTime.format('YYYY-MM-DD HH:mm:ss') : 'NO time';
    const fCurrentTime = currentTime.format('YYYY-MM-DD HH:mm:ss');
    const secondsToExpire = expiryTime ? expiryTime.diff(currentTime, 'seconds') : 0;
    const playingExercise = secondsToExpire > 0;
    const hasStudentResponse = responsesKeys && responsesKeys.includes(`e${currentExercise}`) ? responses[`e${currentExercise}`].find(aR => aR.uid == user.id) : false;

    // console.log('StudentCompetitionStage3 currentTime:', fCurrentTime, 'startedTime:', fStartedTime, 'secondsToExpire:', secondsToExpire, 'playingExercise:', playingExercise);

    if (exercises && currentExercise) {
        const theExercise = exercises[currentExercise - 1];
        theExercise.params.showSolution = false;
        theExercise.params.hideNextButton = true;
        theExercise.params.sendResultsOnComplete = true;
        // console.log(`StudentCompetitionStage3: currentExercise: ${currentExercise}, theExercise:`, theExercise, 'hasStudentResponse:', hasStudentResponse);

        if (playingExercise) {
            const countdownSecs = secondsToExpire - (MAXEXERCISESECONDS - COUNT_DOWN_SECS);
            // console.log(`StudentCompetitionStage3: MyCountDown:`, countdownSecs, enterExercise);

            if (countdownSecs <= COUNT_DOWN_SECS && !enterExercise) {
                return <div className='count-down'><MyCountDown
                    timeout={countdownSecs === COUNT_DOWN_SECS ? (COUNT_DOWN_SECS - 1) : countdownSecs}
                    stopTime={false}
                    timeHandler={() => setEnterExercise(true)} />
                </div>
            } else {
                return <>
                    <div className='waiting'>
                        <span>{expiryTime ? <MyTimer
                            expiryTimestamp={expiryTime.toDate()}
                            stopTime={false}
                            handleExpire={() => { handleExpireTime() }}
                            handleStop={(t) => console.log('stopped:', t)} /> : null}
                        </span>
                    </div>
                    {hasStudentResponse ? <article>
                        <ShowStudentResult lang={lang} response={hasStudentResponse} />
                        <div className='waiting'>
                            <h3 className="code">{t(lang, 'waitingresponses')}</h3>
                            <Spin size="large" className="spinner" />
                        </div>
                    </article> : <article className='competition-exercise'>
                        {genExerciseComponent(theExercise.impl, 'comp', 1, theExercise.params, () => console.log('cancel...'), handleResponse, lang)}
                    </article>}

                </>;
            }
        } else {
            const data = genExerciseStats(responses[`e${currentExercise}`], theCompetition.participants);
            const scores = genCompetitionRanking(responses, theCompetition.participants);

            // console.log(`StudentCompetitionStage3: currentExercise: ${currentExercise}, data:`, data, 'scores:', scores);

            return <section className="response-list">
                {!waitingNext ? <h3 className="exercise-title">{t(lang, exercises[currentExercise - 1].label)}</h3> : <div className='waiting'>
                    <h2 className="code">{t(lang, 'waitingnextchallenge')}</h2>
                    <Spin size="large" className="spinner" />
                </div>}

                <ShowCompetitionResults
                    lang={lang}
                    exercises={exercises}
                    currentExercise={currentExercise}
                    studentResponse={hasStudentResponse || {}}
                    statdata={data}
                    scores={scores}
                    screensToShow={['result', 'solution', 'waiting']}
                    onFinish={() => setWaitingNext(true)}
                />

            </section>;
        }
    } else return null;
}

export default memo(StudentCompetitionStage3);